import React, { useState } from "react";
import { Carousel as CarouselComponent } from "react-responsive-carousel";
import { signup } from "../../resources/js/icons";
import P from "../../shared/typography/P";
const data = [
    {
        img: signup,
        title: "Join Hands",
        discription:
            "Sign up, register, and build a community with fellow owners to invest in the rooftop solar project installed on your premises.",
    },
    {
        img: signup,
        title: "Show Interest",
        discription:
            " By telling us how much you want to invest in the project and help your society save up to 40% on electricity bills.",
    },
    {
        img: signup,
        title: " Invest Together",
        discription:
            " Investors will earn up to 20% returns, and the society will  benefit from significant savings on electricity bills.It's a win-win for everyone!",
    },
];
const WelcomePage = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    return (
        <div className="p-3">
            <CarouselComponent
                selectedItem={currentSlide}
                onChange={setCurrentSlide}
                showArrows={false}
                showStatus={false}
                showThumbs={false}
                showIndicators={false}
                autoPlay={true}
                infiniteLoop={true}
                interval={3000}
                stopOnHover={true}
                transitionTime={500}
                swipeable={true}
                preventMovementUntilSwipeScrollTolerance={true}
                swipeScrollTolerance={50}
                emulateTouch={true}
            >
                {data.map((item, index) => (
                    <div className="text-center w-full mb-2">
                        <img
                            src={item.img}
                            alt="signup"
                            className="w-full h-96 xs:h-full md:h-96 "
                        />
                        <P className="font-medium font-vietnam text-base xs:text-lg mt-5">
                            {item.title}
                        </P>
                        <p className="text-xs xs:text-base md:text-sm font-vietnam mt-1 mb-2 xs:mb-5 md:text-gray-550">
                            {item.discription}
                        </p>
                    </div>
                ))}
            </CarouselComponent>
            <div className="flex justify-center items-center space-x-2 mb-2 xs:mb-4">
                {[0, 1, 2, 3].map((index) => (
                    <div
                        key={index}
                        className={`w-1 h-1 rounded-full cursor-pointer transition-colors duration-300 ${
                            currentSlide === index
                                ? "bg-gray-300"
                                : "bg-gray-400"
                        }`}
                        onClick={() => setCurrentSlide(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default WelcomePage;
